import { inject } from 'vue';
import type { AuthService } from '@/contracts/AuthService';

export function useCurrentUser(auth: AuthService = inject('auth') as AuthService) {
  async function getCurrentUser(): Promise<string> {
    const account = await auth.getActiveAccount();

    if (!account || !account.username) {
      throw new Error('No active account is available.');
    }

    return account.username.split('@')[0].substring(0, 10);
  }

  return { getCurrentUser };
}
